import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";
import Loader from '../../../utils/Loader';
import { yupResolver } from "@hookform/resolvers/yup";
import { useShowManageModuleQuery,useGetCourseListQuery,useUpdateManageModuleMutation} from "../../../Services/api";
export default function Update(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        coursecode: Yup.string().required("course fields is required"),
        lesson_name: Yup.string().required("course name fields is required"),
    });
      const {
        data: ShowManageModule,
        isLoading: isGetLoading,
      } =  useShowManageModuleQuery({  params:props['id']});

      const [UpdateManageModule] = useUpdateManageModuleMutation();
      const showModule= ShowManageModule?.data[0];
      
      var  defaultValues={
        coursecode:showModule?.coursecode,
        lesson_name:showModule?.lesson_name,
      };
    const methods = useForm({
        mode: "onTouched",
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues,
      });
      const {
          register,
          handleSubmit,
          reset,
          formState: { errors },
        } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[showModule]) 
      
    const updateModuleList = (values,e) => {
        UpdateManageModule({ data: values,param:props['id'] })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    }; 
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Exam</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Exam</h5>
                        <form onSubmit={handleSubmit(updateModuleList)} >
                       
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                <select  {...register("coursecode")} className="form-control" >
                                    <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    <span className="text-danger">{errors.coursecode?.message}</span>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Module Name</label>
                                <div className="col-sm-10">
                                    <input type="name" {...register("lesson_name")} className="form-control" />
                                    <span className="text-danger">{errors.lesson_name?.message}</span>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-warning">Save changes</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}